/**
 * iter304 · Global `?ref=CODE` catcher
 * ─────────────────────────────────────────────────────────────────────
 * Mounted once in App.js. Any time the URL contains `?ref=CODE` (on
 * any route, not just `/r/:code`), we stash the code so the eventual
 * signup / login credits the ambassador. No UI — invisible utility.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { stashReferralCode } from '../../utils/referralCode';

export default function ReferralCodeCatcher() {
  const location = useLocation();
  useEffect(() => {
    try {
      const p = new URLSearchParams(location.search);
      const code = p.get('ref');
      if (code) stashReferralCode(code);
    } catch (_) { /* ignore */ }
  }, [location.search]);
  return null;
}
